<template>
  <v-container>
    <v-layout align-center justify-center row wrap fill-height>
      <div><h2>Kod QR</h2></div>
    </v-layout>

    <v-layout align-center justify-center row wrap fill-height>
      <div>
        <img :src="qrcode"/>
      </div>
    </v-layout>

    <v-layout align-center justify-center row wrap fill-height>
      <div>
        <h3 style="text-align: center">Instrukcja</h3>
        <h5 style="text-align: center">Konfigurowanie aplikacji mobilnej przy użyciu kodu QR</h5>
        <p>1. Uruchom aplikację mobilną 2Form.</p>
        <p>2. Bedąc na ekranie startowym przejdź do konfiguracji api poprzez kliknięcie ikony, która znajduje się w prawym dolnym rogu ekranu.</p>
        <p>3. Naciśnij przycisk z kodem kreskowym.</p>
        <p>4. Zeskanuj kod QR. Kod straci ważność po 4h.</p>
        <p>5. Voilà! Aplikacja skonfigurowana.</p>
      </div>
    </v-layout>
  </v-container>
</template>

<script >
export default {
  data() {
    return {
      qrcode: ""
    }
  },
  created(){
    this.$http.get('mobile/settings/qrcode').then(data =>{
      this.qrcode = data.data
    }).catch(()=>{})
  }
}
</script>

<style scoped>

</style>